import { render, staticRenderFns } from "./ViewOrganisation.vue?vue&type=template&id=028b13d2&"
import script from "./ViewOrganisation.vue?vue&type=script&lang=ts&"
export * from "./ViewOrganisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports